export default __webpack_public_path__ + "static/partner_badge_banner-f7a0309133fc1266884bcdccf47b1fd7.svg";